module.exports = __webpack_public_path__ + "static/media/18ECA3.a2f6b6fe.jpg";